var stIsIE = /*@cc_on!@*/false;
var sorttable =  {
	ajax_order : function(table){		// Initialize order from php's $_SESSION, if possible.
		var first_ = table.id.indexOf('_');
		var gid = table.id.slice(first_ + 1);
		while(gid.indexOf('_') != gid.lastIndexOf('_')){
			gid = gid.slice(gid.indexOf('_') + 1);
		}
		new Ajax.Request(['/ajax/sort_order', table.id.slice(0, first_),''].join('/'), {
			method:'post', 
			parameters: {'action':'get', 'group': gid, 'parent_id': location.href.match(/\/(\d+)\//)[1]+''}, 
			onSuccess: function(ret){
				alert(ret.responseText);
				// TODO: sort table by data retrieved
			}
		});
	},
	init: function(callback){
		sorttable.DATE_RE = /^(\d\d?)[\/\.-](\d\d?)[\/\.-]((\d\d)?\d\d)$/;
		$$('table.sortable').each(function(tbl){
			sorttable.makeSortable(tbl, callback);
		});
	},
	makeSortable: function(table, callback){
		if(table.sorted_already)
			return;
		table.sorted_already = true;

		if(!table.hasClassName('item_table'))
		{
			if(table.getElementsByTagName('thead').length == 0){
				var the = document.createElement('thead');
				the.appendChild(table.rows[0]);
				table.insertBefore(the,table.firstChild);
			}
			if(table.tHead == null) table.tHead = table.getElementsByTagName('thead')[0];
			if(!table.hasClassName('sub_sortable') && table.tHead.rows.length != 1)
				return; // non-sub_sortable can't cope with two header rows
		}

		var sortbottomrows = [];
		for (var i=0; i<table.rows.length; i++){
			if(table.rows[i].className.search(/\bsortbottom\b/) != -1){
				sortbottomrows[sortbottomrows.length] = table.rows[i];
			}
		}
		if(sortbottomrows){
			if(table.tFoot == null){
				var tfo = document.createElement('tfoot');
				table.appendChild(tfo);
			}
			for (var i=0; i<sortbottomrows.length; i++){
				tfo.appendChild(sortbottomrows[i]);
			}
			delete sortbottomrows;
		}

		var headrow = [];
		if(table.hasClassName('sub_sortable'))
		{
			for(var i = 0; i < table.tHead.rows.length; i++)
			{
				var sub_headrow = Array.prototype.slice.call(table.tHead.rows[i].cells);
				for(var j = 0; j < sub_headrow.length; j++)
				{
					sub_headrow[j].sub_sorttable_columnindex = j;
					sub_headrow[j].sorttable_columnindex = get_node_index(table.up('td'));
					sub_headrow[j].sub_sorttable_columnindex = get_node_index(table.up('div'));
					sub_headrow[j].sub_sorttable_columnindex2 = get_node_index(sub_headrow[j]);
					sub_headrow[j].sorttable = table.up('table');
					sub_headrow[j].sorttable_tbody = sub_headrow[j].sorttable.tBodies[0];
				}
				headrow = headrow.concat(sub_headrow);
			}
		}
		else if(table.hasClassName('item_table'))
		{
			// Some `item_table`s have labels on every row
			var headrow_length = table.tBodies[0].down('tr').select('.pao_label').length;
			headrow = table.select('.pao_label');

			// Some tables have a tbody for each row, others have only one tbody
			for(var i = 0; i < headrow.length; i++)
			{
				headrow[i].sorttable_columnindex = i % headrow_length;
				headrow[i].sorttable_tbody = table.tBodies[0];
			}
		}
		else
			headrow = Array.prototype.slice.call(table.tHead.rows[0].cells);

		for (var i=0; i<headrow.length; i++){
			if(!headrow[i].className.match(/\bsorttable_nosort\b/)){		// skip this col
				var mtch = headrow[i].className.match(/\bsorttable_([a-z0-9]+)\b/);
				if(mtch){ var override = mtch[1]; }
				if(mtch && typeof sorttable["sort_"+override] == 'function')
					headrow[i].sorttable_sortfunction = sorttable["sort_"+override];
				else if(table.hasClassName('item_table'))
					headrow[i].sorttable_sortfunction = sorttable.guessType(table, headrow[i].sorttable_columnindex);
				else if(table.hasClassName('sub_sortable'))
					headrow[i].sorttable_sortfunction = sorttable.guessType(table, headrow[i].sub_sorttable_columnindex2);
				else
					headrow[i].sorttable_sortfunction = sorttable.guessType(table,i);
				if(!table.hasClassName('sub_sortable'))
				{
					if(!table.hasClassName('item_table'))
					{
						headrow[i].sorttable_columnindex = i;
						headrow[i].sorttable_tbody = table.tBodies[0];
					}
					headrow[i].sorttable = table;
				}

				dean_addEvent(headrow[i],"click", function(e){
					var reports_rows = reports_hide_all(table);

					if(this.className.search(/\bsorttable_sorted\b/) != -1){
						sorttable.reverse(this);
						sorttable.relocate_footers(this.sorttable);
						this.className = this.className.replace('sorttable_sorted', 'sorttable_sorted_reverse');
						reports_restore_open(reports_rows);
						if(table.hasClassName('item_table'))
							sorttable.shift_item_table_header(table, this, this.sorttable_columnindex, 'sorttable_sorted', 'sorttable_sorted_reverse');
						if(callback)
							callback.call(this, table.id);
						return;
					}

					if(this.className.search(/\bsorttable_sorted_reverse\b/) != -1){
						sorttable.reverse(this);
						sorttable.relocate_footers(this.sorttable);
						this.className = this.className.replace('sorttable_sorted_reverse', 'sorttable_sorted');
						reports_restore_open(reports_rows);
						if(table.hasClassName('item_table'))
							sorttable.shift_item_table_header(table, this, this.sorttable_columnindex, 'sorttable_sorted_reverse', 'sorttable_sorted');
						if(callback)
							callback.call(this, table.id);
						return;
					}

					var theads = [];
					if(table.hasClassName('sub_sortable'))
						theads = this.up('table').up('table').select('th');
					else if(table.hasClassName('item_table'))
						theads = this.up('table').select('.pao_label');
					else
						theads = this.up('table').select('th');
					forEach(theads, function(cell)
					{
						if(cell.nodeType == 1){ // an element
							cell.removeClassName('sorttable_sorted_reverse');
							cell.removeClassName('sorttable_sorted');
						}
					});

					var sortfwdind = document.getElementById('sorttable_sortfwdind');
					if(sortfwdind){ sortfwdind.parentNode.removeChild(sortfwdind); }
					var sortrevind = document.getElementById('sorttable_sortrevind');
					if(sortrevind){ sortrevind.parentNode.removeChild(sortrevind); }

					this.addClassName('sorttable_sorted');

					var row_array = [];
					var col = this.sorttable_columnindex;
					if (this.sorttable.tBodies.length < 2) {
						var rows = this.sorttable_tbody.rows;
						if(table.hasClassName('sub_sortable'))
						{
							for (var j=0; j<rows.length; j++){
								row_array[row_array.length] = [sorttable.getInnerText(rows[j].cells[col].select('.sub_sortable')[this.sub_sorttable_columnindex].select('tbody')[0].select('tr')[0].cells[this.sub_sorttable_columnindex2]), rows[j]];
							}
						}
						else if(table.hasClassName('item_table'))
						{
							for (var j=0; j<rows.length; j++){
								row_array[row_array.length] = [sorttable.get_item_table_text(rows[j].select('.pao_bottom')[col]), rows[j]];
							}
						}
						else
						{
							for (var j=0; j<rows.length; j++){
								row_array[row_array.length] = [sorttable.getInnerText(rows[j].cells[col]), rows[j]];
							}
						}
						sorttable.shaker_sort(row_array, this.sorttable_sortfunction);
						var tb = this.sorttable_tbody;
						for (var j=0; j<row_array.length; j++){
							tb.appendChild(row_array[j][1]);
						}
						GUI.zebrify($(tb).childElements());
					}
					else
					{
						if(!table.hasClassName('item_table'))
							rows = this.sorttable.select('tr.sort');
						else
							rows = this.sorttable.rows;
						var rowlen = rows.length;
						if(table.hasClassName('sub_sortable'))
						{
							for (var j=0; j<rowlen; j++)
							{
								row_array[j] = [sorttable.getInnerText(rows[j].cells[col].select('.sub_sortable')[this.sub_sorttable_columnindex].select('tbody')[0].select('tr')[0].cells[this.sub_sorttable_columnindex2]), rows[j]];
							}
						}
						else if(table.hasClassName('item_table'))
						{
							for(var j = 0; j < rowlen; j++)
							{
								row_array[j] = [sorttable.get_item_table_text(rows[j].select('.pao_bottom')[col]), rows[j]];
							}
						}
						else
						{
							for (var j=0; j<rowlen; j++){
								row_array[j] = [sorttable.getInnerText(rows[j].cells[col]), rows[j]];
							}
						}

						sorttable.shaker_sort(row_array, this.sorttable_sortfunction);
						var tbl = this.sorttable;
						for (var j=0; j<rowlen; j++) {
							tbl.appendChild($(row_array[j][1]).up('tbody'));
						}
						sorttable.relocate_footers(tbl);
						tbl.appendChild($(tbl).down('tfoot'));
						
						GUI.zebrify(Array.prototype.slice.call(this.sorttable.tBodies));
					}
					delete row_array;
					
					if(table.hasClassName('item_table'))
						sorttable.shift_item_table_header(table, this, this.sorttable_columnindex, '', 'sorttable_sorted');
					if(this.up('table').hasClassName('sub_sortable'))
						sorttable.set_sub_sortable_header_classes(table.up('table'), this, '', 'sorttable_sorted');

					// Multiple-column sorting
					if(this.up('table').select('.multi_sortable').length > 0)
					{
						// List columns used for multi-sort, in order of priority
						var primary_sort_col = this.getAttribute('data-multisort');
						var multisort_cols = [];
						this.up('table').select('.multi_sortable').each(function(column)
						{
							var sort_order = column.getAttribute('data-multisort');
							if(sort_order === primary_sort_col) // skip column if already sorted upon
								return;
							multisort_cols.push(column);
						});

						sorttable.shaker_sort(multisort_cols, function(a, b)
						{
							var aa = a.getAttribute('data-multisort');
							var bb = b.getAttribute('data-multisort');
							return bb - aa;
						});

						sorttable.multisort(this.sorttable, this.sorttable.select('tr.sort'), this, multisort_cols, 0);
						GUI.zebrify(Array.prototype.slice.call(this.sorttable.tBodies));
					}

					reports_restore_open(reports_rows);
					if(callback)
						callback.call(this, table.id);
				});
			}
		}
	},
	relocate_footers: function(tbl) {
		var footers = tbl.select('tbody.footer');
		var footerlen = footers.length;
		for (var j=0; j<footerlen; j++) {
			tbl.appendChild(footers[j]);
		}
	},
	multisort: function(table, rows, main_col, next_cols, node_offset, recursion)
	{
		if(rows.length < 2)
			return;
		if(!recursion)
			recursion = 0;

		var sort_col_index = main_col.sorttable_columnindex;
		if(recursion) // Assume rows are already sorted on main_col on first non-recursive call
		{
			var row_array = [];
			for(var j = 0; j < rows.length; j++)
			{
				row_array[row_array.length] = [sorttable.getInnerText(rows[j].cells[sort_col_index]), rows[j]];
			}
			sorttable.shaker_sort(row_array, main_col.sorttable_sortfunction);

			var sorted_rows = [];
			for(var j = 0; j < row_array.length; j++)
			{
				sorted_rows.push(row_array[j][1]);
				table.insertBefore(row_array[j][1].up('tbody'), table.childElements().grep(new Selector('tbody'))[node_offset + j]);
			}
			rows = sorted_rows;
		}

		if(next_cols.length > 0)
		{
			var next_main_col = next_cols[0];
			var next_next_cols = [];
			for(var i = 1; i < next_cols.length; i++)
			{
				next_next_cols.push(next_cols[i]);
			}
			var search_value = sorttable.getInnerText(rows[0].cells[sort_col_index]);
			var subset = [];
			var sort_next = false;
			for(var i = 0; i < rows.length; i++)
			{
				var test_case = sorttable.getInnerText(rows[i].cells[sort_col_index]);
				if(test_case == search_value)
					subset.push(rows[i]);
				else
					sort_next = true;
				if(sort_next || i == rows.length - 1)
				{
					var next_node_offset = node_offset + i - subset.length;
					if(i == rows.length - 1)
						next_node_offset++;
					sorttable.multisort(table, subset, next_main_col, next_next_cols, next_node_offset, recursion + 1);
					subset = [];
					sort_next = false;
					search_value = test_case;
					if(i < rows.length - 1)
						i--;
				}
			}
		}
	},

	guessType: function(table, column){
		var sortfn = sorttable.sort_alpha;
		for (var i=0; i<table.tBodies[0].rows.length; i++){
			if(table.hasClassName('item_table'))
			{
				if(table.hasClassName('single_tbody'))
					var text = sorttable.get_item_table_text(table.tBodies[0].select('tr')[i].select('.pao_bottom')[column]);
				else
					var text = sorttable.get_item_table_text(table.tBodies[i].down('tr').select('.pao_bottom')[column]);
			}
			else
				text = sorttable.getInnerText(table.tBodies[0].rows[i].cells[column]);
			if(text != ''){
				if(text.match(/^-?[£$¤]?[\d,.]+%?$/))
					return sorttable.sort_numeric;
				var possdate = text.match(sorttable.DATE_RE)
				if(possdate){
					var first = parseInt(possdate[1]);
					var second = parseInt(possdate[2]);
					if(first > 12){
						return sorttable.sort_ddmm;
					} else if(second > 12){
						return sorttable.sort_mmdd;
					} else {
						sortfn = sorttable.sort_ddmm;
					}
				}
			}
		}
		return sortfn;
	},
	getInnerText: function(node){
		if(!node) return '';	// in other words, fail quietly.
		var hasInputs = (typeof node.getElementsByTagName == 'function') &&
			node.getElementsByTagName('input').length;
		if(node.getAttribute("sorttable_customkey") != null)
			return node.getAttribute("sorttable_customkey");
		else if(typeof node.textContent != 'undefined' && !hasInputs)
			return node.textContent.replace(/^\s+|\s+$/g, '');
		else if(typeof node.innerText != 'undefined' && !hasInputs)
			return node.innerText.replace(/^\s+|\s+$/g, '');
		else if(typeof node.text != 'undefined' && !hasInputs)
			return node.text.replace(/^\s+|\s+$/g, '');
		else {
			switch (node.nodeType){
				case 3:
					if(node.nodeName.toLowerCase() == 'input'){
						return node.value.replace(/^\s+|\s+$/g, '');
					}
					break;
				case 4:
					return node.nodeValue.replace(/^\s+|\s+$/g, '');
				case 1:
				case 11:
					var innerText = '';
					for (var i = 0; i < node.childNodes.length; i++){
						innerText += sorttable.getInnerText(node.childNodes[i]);
					}
					return innerText.replace(/^\s+|\s+$/g, '');
				default:
					return '';
			}
		}
	},

	get_item_table_text: function(cell)
	{
		try{
			if(!cell)
			{
				console.log('Argument `cell` is undefined!');
				var err = new Error();
				if(typeof err.stack !== 'undefined') // not supported in IE9
					console.log(err.stack);
				return false;
			}
	
			if(cell.select('input').length > 0){
				if(cell.select('input')[0].attributes.sorttable_customkey)
					var text =cell.select('input')[0].attributes.sorttable_customkey.nodeValue
				else
					var text = cell.select('input')[0].value;
			}
			else if(cell.select('select').length > 0 && cell.select('select')[0][cell.select('select')[0].selectedIndex])
				var text = cell.select('select')[0][cell.select('select')[0].selectedIndex].innerHTML;
			else if(cell.select('a').length > 0 && cell.select('a').last() && cell.select('a').last().innerHTML)
				var text = cell.select('a').last().innerHTML;
			else
				var text = cell.innerHTML;
			text = text.trim();
			if(text.charAt(0) === get_currency_symbol())
				text = text.substr(1);
			else if(text.search(/\b\d \d\/\d\b/) === 0)
			{
				var parts = text.split(' ');
				if(parts.length == 2)
				{
					var more_parts = parts[1].split('/');
					text = parseInt(parts[0]) + (more_parts[0] / more_parts[1]);
				}
			}
			else if(text.search(/\b\d\/\d\b/) === 0)
			{
				var parts = text.split('/');
				if(parts.length == 2)
					text = parts[0] / parts[1];
			}
			text = text.toString();
			if(text === '' || text === '-')
				text = '0'; // More often than not, blank fields on this kind of table are meant to be numeric
	
			return text;
		}
		catch(error){
			console.log(error, 'sorting error');
		}
		
	},

	reverse: function(ele){
		var newrows = [];
		if (ele.sorttable.tBodies.length < 2) {
			var tbody = ele.sorttable_tbody;
			for (var i=0; i<tbody.rows.length; i++){
				newrows[newrows.length] = tbody.rows[i];
			}
			for (var i=newrows.length-1; i>=0; i--){
				tbody.appendChild(newrows[i]);
			}
			GUI.zebrify($(tbody).childElements())
		}
		else {
			if(!ele.sorttable.hasClassName('item_table'))
				var rows = ele.sorttable.select('tr.sort');
			else
				var rows = ele.sorttable.rows;
			var rowlen = rows.length;
			for (var j=rowlen-1; j>=0; j--){
				ele.sorttable.appendChild($(rows[j]).up('tbody'));
			}
			ele.sorttable.appendChild($(ele.sorttable).down('tfoot'));

			GUI.zebrify(Array.prototype.slice.call(ele.sorttable.tBodies));
		}
		delete newrows;
	},
	sort_numeric: function(a,b){
		var aa = parseFloat(a[0].replace(/[^0-9.-]/g,''));
		if(isNaN(aa)) aa = 0;
		var bb = parseFloat(b[0].replace(/[^0-9.-]/g,'')); 
		if(isNaN(bb)) bb = 0;
		return aa-bb;
	},
	sort_alpha: function(a,b){
		a[0] = a[0].toLowerCase();
		b[0] = b[0].toLowerCase();
		if(a[0]==b[0]) return 0;
		if(a[0]<b[0]) return -1;
		return 1;
	},
	sort_ddmm: function(a,b){
		var mtch = a[0].match(sorttable.DATE_RE);
		var y = mtch[3]; 
		var m = mtch[2]; 
		var d = mtch[1];
		if(m.length == 1) m = '0'+m;
		if(d.length == 1) d = '0'+d;
		var dt1 = y+m+d;
		mtch = b[0].match(sorttable.DATE_RE);
		y = mtch[3]; m = mtch[2]; d = mtch[1];
		if(m.length == 1) m = '0'+m;
		if(d.length == 1) d = '0'+d;
		var dt2 = y+m+d;
		if(dt1==dt2) return 0;
		if(dt1<dt2) return -1;
		return 1;
	},
	sort_mmdd: function(a,b){
		var mtch = a[0].match(sorttable.DATE_RE);
		var y = mtch[3]; 
		var d = mtch[2]; 
		var m = mtch[1];
		if(m.length == 1) m = '0'+m;
		if(d.length == 1) d = '0'+d;
		var dt1 = y+m+d;
		mtch = b[0].match(sorttable.DATE_RE);
		y = mtch[3]; d = mtch[2]; m = mtch[1];
		if(m.length == 1) m = '0'+m;
		if(d.length == 1) d = '0'+d;
		var dt2 = y+m+d;
		if(dt1==dt2) return 0;
		if(dt1<dt2) return -1;
		return 1;
	},
	shaker_sort: function(list, comp_func){
		var b = 0;
		var t = list.length - 1;
		var swap = true;
		while(swap){
				swap = false;
				for(var i = b; i < t; ++i){
						if( comp_func(list[i+1], list[i]) > 0 ){
								var q = list[i]; list[i] = list[i+1]; list[i+1] = q;
								swap = true;
						}
				} // for
				t--;
				if(!swap) break;
				for(var i = t; i > b; --i){
						if( comp_func(list[i-1], list[i]) < 0 ){
								var q = list[i]; list[i] = list[i-1]; list[i-1] = q;
								swap = true;
						}
				} // for
				b++;
		} // while(swap)
	},

	shift_item_table_header: function(table, element, sorttable_columnindex, remove_class, add_class)
	{
		var top_row = table.tBodies[0].down('tr');
		if(top_row.select('.pao_label').length == 0)
		{
			var top_row_cells = top_row.select('.pao_td');
			var headers = table.select('.pao_label');

			for(var i = 0; i < headers.length; i++)
				top_row_cells[i].insertBefore(headers[i], top_row_cells[i].down('.pao_bottom'));
		}

		if(add_class)
		{
			var rows = [];
			if(table.tBodies.length < 2)
				rows = Array.prototype.slice.call(table.tBodies[0].rows);
			else
			{
				Array.prototype.slice.call(table.tBodies).each(function(row)
				{
					rows.push(row.down('tr'));
				});
			}
			rows.each(function(row)
			{
				var row_labels = row.select('.pao_label')
				if(!row_labels.length) // labels only exist on top row
					throw $break;
				if(remove_class)
					row_labels[sorttable_columnindex].removeClassName(remove_class);
				row_labels[sorttable_columnindex].addClassName(add_class);
			});
		}
	},

	set_sub_sortable_header_classes: function(table, element, remove_class, add_class)
	{
		if(add_class)
		{
			var rows = [];
			if(table.tBodies.length < 2)
				rows = Array.prototype.slice.call(table.tBodies[0].rows);
			else
			{
				Array.prototype.slice.call(table.tBodies).each(function(row)
				{
					rows.push(row.down('tr'));
				});
			}
			rows.each(function(row)
			{
				Array.prototype.slice.call(row.select('.sub_sortable')[element.sub_sorttable_columnindex].tHead.rows).each(function(thead_row)
				{
					if(thead_row.cells[element.sub_sorttable_columnindex2])
					{
						if(remove_class)
							thead_row.cells[element.sub_sorttable_columnindex2].removeClassName(remove_class);
						thead_row.cells[element.sub_sorttable_columnindex2].addClassName(add_class);
					}
				});
			});
		}
	}
}

function dean_addEvent(element, type, handler){
	if(element.addEventListener){
		element.addEventListener(type, handler, false);
	} else {
		if(!handler.$$guid) handler.$$guid = dean_addEvent.guid++;
		if(!element.events) element.events = {};
		var handlers = element.events[type];
		if(!handlers){
			handlers = element.events[type] = {};
			if(element["on" + type]){
				handlers[0] = element["on" + type];
			}
		}
		handlers[handler.$$guid] = handler;
		element["on" + type] = handleEvent;
	}
	var table = element.up('table');
	if(table.hasClassName('item_table'))
	{
		if(!table.click_handler_ref)
			table.click_handler_ref = handler;
	}
};
dean_addEvent.guid = 1;
function removeEvent(element, type, handler){
	if(element.removeEventListener){
		element.removeEventListener(type, handler, false);
	} else {
		if(element.events && element.events[type]){
			delete element.events[type][handler.$$guid];
		}
	}
};
function handleEvent(event){
	var returnValue = true;
	event = event || fixEvent(((this.ownerDocument || this.document || this).parentWindow || window).event);
	var handlers = this.events[event.type];
	for (var i in handlers){
		this.$$handleEvent = handlers[i];
		if(this.$$handleEvent(event) === false){
			returnValue = false;
		}
	}
	return returnValue;
};
function fixEvent(event){
	event.preventDefault = fixEvent.preventDefault;
	event.stopPropagation = fixEvent.stopPropagation;
	return event;
};
fixEvent.preventDefault = function(){
	this.returnValue = false;
};
fixEvent.stopPropagation = function(){
	this.cancelBubble = true;
}
if(!Array.forEach){ // mozilla already supports this, as does virtually everyone
	Array.forEach = function(array, block, context){
		for (var i = 0; i < array.length; i++){
			block.call(context, array[i], i, array);
		}
	};
}
Function.prototype.forEach = function(object, block, context){
	for (var key in object){
		if(typeof this.prototype[key] == "undefined"){
			block.call(context, object[key], key, object);
		}
	}
};
String.forEach = function(string, block, context){
	Array.forEach(string.split(""), function(chr, index){
		block.call(context, chr, index, string);
	});
};
var forEach = function(object, block, context){
	if(object){
		var resolve = Object; // default
		if(object instanceof Function){
			resolve = Function;
		} else if(object.forEach instanceof Function){
			object.forEach(block, context);
			return;
		} else if(typeof object == "string"){
			resolve = String;
		} else if(typeof object.length == "number"){
			resolve = Array;
		}
		resolve.forEach(object, block, context);
	}
};
Event.observe(window,'load',sorttable.init);